export default "__VITE_ASSET__4409cdaa__"